import { TPAComponentProps } from '../../types';
import {
  LanguageType as WSRLanguageType,
  LocaleUtils,
} from 'wix-style-react-tpa';

export type WeeklyDateNavigationLanguageType = WSRLanguageType;

export type WeeklyDateNavigationFirstDayOfWeek = LocaleUtils.FirstDayOfWeek;
export interface WeeklyDateNavigationProps extends TPAComponentProps {
  /** The ID for the heading element. Must be the same as the labelled-by in Table (React Day Picker). */
  captionId?: string;
  /** The current displayed week range. */
  value: { startOfWeek: Date; endOfWeek: Date };

  /** Defines a callback function that is called with the range of the current displayed week whenever the displayed week is changed. */
  onChange({
    startOfWeek,
    endOfWeek,
  }: {
    startOfWeek: Date;
    endOfWeek: Date;
  }): void;

  /** First day of the week, allowing only from 0 to 6 (Sunday to Saturday). The default value is 1 which means Monday. */
  firstDayOfWeek?: WeeklyDateNavigationFirstDayOfWeek;

  /** WeeklyDateNavigation instance locale */
  locale?: WeeklyDateNavigationLanguageType;

  /** Defines a string value that labels the prev arrow in calendar header */
  prevArrowAriaLabel?: string;

  /** Identifies the element that labels the prev arrow in calendar header */
  prevArrowAriaLabelledBy?: string;

  /** Defines a string value that labels the next arrow in calendar header */
  nextArrowAriaLabel?: string;

  /** Identifies the element that labels the next arrow in calendar header */
  nextArrowAriaLabelledBy?: string;
}

export interface WeeklyDateNavigationDefaultProps {
  locale: WeeklyDateNavigationLanguageType;
}
